import world from './de/world.de';
import auth from './de/auth.de';
import editors from './de/editors.de';

export default {
  ...world,
  ...auth,
  ...editors,
};
